import { RootState } from "../../typescript/redux";

export const getAuth = (state: RootState) => state.auth;

export const isUserLoggedIn = (state: RootState) => state.auth.isLoggedIn;

export const isLoadingLogin = (state: RootState) => state.auth.isLoading;

export const getUser = (state: RootState) => state.auth.user;
